module.exports = __webpack_public_path__ + "assets/img/991587020601_.pic_hd.2dac7fb0.jpg";